import { useEffect, useState } from 'react';
import loadMarkdownToHTML from '../editor/utils/loadMarkdownToHTML';

const useMarkdownToHTML = (skip?: boolean) => {
  const [markdownToHTML, setMarkdownToHTML] = useState<
    ((markdown: string) => string | null) | null
  >(null);

  useEffect(() => {
    if (!skip && !markdownToHTML) {
      loadMarkdownToHTML().then((markdownToHTMLFn) =>
        // Can't set directly as `setMarkdownToHTML(markdownToHTMLFn)`
        // because it would trigger the functional version of SetStateAction
        // and call the markdownToHTMLFn with empty input
        setMarkdownToHTML(() => markdownToHTMLFn),
      );
    }
  }, [skip, markdownToHTML]);

  return markdownToHTML;
};

export default useMarkdownToHTML;
